import { BusinessSettingsLayout } from '@/components/business-settings/BusinessSettingsLayout';
import { EmployeeManagementSection } from '@/components/business-settings/EmployeeManagementSection';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function PeopleSettings() {
  return (
    <BusinessSettingsLayout
      title="People Settings"
      description="Manage employee profiles, roles, and team organization"
    >
      <div className="space-y-6">
        <EmployeeManagementSection />


        <Card>
          <CardHeader>
            <CardTitle>Team Organization</CardTitle>
            <CardDescription>
              Set up departments, teams, and reporting structures
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-8 text-muted-foreground">
              <p>Team organization settings will be available here.</p>
              <p className="text-sm mt-2">This is a placeholder for future implementation.</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </BusinessSettingsLayout>
  );
}
